import { SVGProps, Ref, forwardRef } from 'react';

export const AppleBrandAltSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M13.235 5.773c-.082.063-1.515.871-1.515 2.667 0 2.078 1.824 2.813 1.878 2.831-.008.045-.29 1.007-.961 1.987-.6.863-1.226 1.724-2.178 1.724s-1.197-.553-2.296-.553c-1.071 0-1.452.571-2.323.571-.87 0-1.478-.798-2.177-1.778-.81-1.151-1.463-2.94-1.463-4.636 0-2.722 1.77-4.165 3.512-4.165.925 0 1.696.607 2.278.607.553 0 1.415-.644 2.468-.644.399 0 1.833.037 2.777 1.39"
            fill="white"
        />
        <path
            d="M9.958 3.232c.436-.517.744-1.234.744-1.95 0-.1-.009-.2-.027-.282-.708.027-1.551.472-2.06 1.061-.399.454-.771 1.17-.771 1.898 0 .109.018.218.027.253.044.008.117.018.19.018.636 0 1.435-.426 1.897-.998"
            fill="white"
        />
    </svg>
));
AppleBrandAltSize16Glyph.displayName = 'AppleBrandAltSize16Glyph';
